module.exports = __webpack_public_path__ + "img/20180815_150119_054.bda91e54.jpg";